// Styles
import '@mdi/font/css/materialdesignicons.css'
import './knockout-icons/knockout-icons.css'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Vuetify
import {createVuetify} from 'vuetify'
import {VClassIcon} from 'vuetify/lib/composables/icons.js'
import {h} from 'vue'

// Custom knockout icon set
const ko = {
    component: (props) => h(VClassIcon, {
        ...props,
        icon: `ko-${props.icon}`,
        class: '',
    }),
}

const knockoutTheme = {
    dark: true,
    colors: {
        background: '#090B12',
        surface: '#11141F',
        'surface-variant': '#161A28',
        'surface-nested': '#1A1E2C',
        primary: '#6BA3D6',
        secondary: '#C084FC',
        info: '#A8B8CC',
        success: '#69ac81',
        danger: '#E2B93B',
        warning: '#D4854A',
        error: '#ac6972',
        'on-background': '#EDEFF7',
        'on-surface': '#EDEFF7',
        'on-surface-variant': '#EDEFF7',

        // Abilities
        power: '#d7e0c6',
        heal: '#69ac81',
        damage: '#E05252',
        stun: '#E8943A',
        buff: '#5B8FD6',
        debuff: '#C084FC',
        hot: '#69ac81',
        dot: '#E05252',

        // Tiers
        gold: '#FFD700',
        silver: '#c0c0c0',
        bronze: '#cd7f32',
        platinum: '#E5E9F0',

        // Health Bar
        'health-high': '#a6c45e',
        'health-mid': '#dba042',
        'health-low': '#c07656',

        // Currencies
        'coins': '#DAA520',
        'tickets': '#C9A96E',
        'attribute-points': '#7BA7C9',

        // Characters
        amun: '#E0A82E',
        box: '#00C2D6',
        eryndras: '#3D7BE8',
        kaze: '#D22730',
        lupus: '#6E6357',
        omega: '#8FA3B8',
        sever: '#7FD63A',
        smoke: '#9AA0A6',
        swarm: '#8E3BE0',
        titus: '#C6702A',
        toshi: '#5B4BD6',
        v4: '#5C6BC0',

        // Characters - Platinum
        skeld: '#1E9E7A',
        ampere: '#E0508F',
        suture: '#C9B037',
        parallax: '#3E4C6D',
    },
}

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        sets: {
            ko,
        },
    },
    theme: {
        defaultTheme: 'knockoutTheme',
        themes: {
            knockoutTheme,
        },
    },
    defaults: {
        global: {
            style: {fontFamily: "'Inter', sans-serif"},
        },
        // App-wide modal sizing: every v-dialog caps at 480px unless it sets its
        // own max-width. A component prop overrides this default.
        VDialog: {
            maxWidth: 512,
        },
    },
});
